webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(17)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(32),
  /* scopeId */
  "data-v-4414a7f0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(16)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(5),
  /* template */
  __webpack_require__(31),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Calculator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Calculator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Calculator__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Calculator: __WEBPACK_IMPORTED_MODULE_0__components_Calculator___default.a
  },
  data: function data() {
    return {
      recoveryTimeObjective: 173520,
      rtoInputs: {
        recoveryTimeObjective: 84,
        recoveryPointObjective: 84
      }
    };
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RangeSlider__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RangeSlider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__RangeSlider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InputTime__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InputTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__InputTime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InputNumber__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InputNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__InputNumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InputSwitch__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InputSwitch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__InputSwitch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Results__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Results___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Results__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'calculator',
  components: {
    RangeSlider: __WEBPACK_IMPORTED_MODULE_0__RangeSlider___default.a,
    InputTime: __WEBPACK_IMPORTED_MODULE_1__InputTime___default.a,
    InputNumber: __WEBPACK_IMPORTED_MODULE_2__InputNumber___default.a,
    InputSwitch: __WEBPACK_IMPORTED_MODULE_3__InputSwitch___default.a,
    Results: __WEBPACK_IMPORTED_MODULE_4__Results___default.a
  },
  data: function data() {
    return {
      recoveryTimeObjective: 84,
      recoveryPointObjective: 84,
      dataDisrupted: 250,
      timeBetweenBackups: 46080,
      timeInitiateBackup: 46080,
      affectedEmployees: 50,
      averageWage: 100,
      overheadCost: 100,
      businessLost: 1000,
      recoverySpeed: 716800

    };
  },

  methods: {
    updateValue: function updateValue(model, value) {
      this[model] = Number(value);
    }
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'input-number',
  props: ['model', 'label', 'value', 'min', 'max'],
  data: function data() {
    return {};
  },

  methods: {
    updateValue: function updateValue(e) {
      this.$emit('update-value', this.model, e.target.value);
    },
    decrease: function decrease(e) {
      var newValue = this.value - 1;
      if (newValue >= this.min) {
        this.$emit('update-value', this.model, newValue);
      } else {
        if (this.model === 'minutes') {
          this.$emit('hit-minute-min');
        } else {
          this.$emit('update-value', this.model, this.min);
        }
      }
    },
    increase: function increase(e) {
      var newValue = this.value + 1;
      if (newValue <= this.max) {
        this.$emit('update-value', this.model, newValue);
      } else {
        if (this.model === 'minutes') {
          this.$emit('hit-minute-max');
        } else {
          this.$emit('update-value', this.model, this.min);
        }
      }
    }
  }

});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'input-switch',
  props: ['model', 'nameOne', 'nameTwo', 'labelOne', 'labelTwo', 'valueOne', 'valueTwo'],
  data: function data() {
    return {
      optionTwo: false
    };
  },

  methods: {
    updateValue: function updateValue(e) {
      this.optionTwo = !this.optionTwo;
      if (this.optionTwo) {
        this.$emit('update-value', this.model, this.valueTwo);
      } else {
        this.$emit('update-value', this.model, this.valueOne);
      }
    }
  }

});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InputNumber__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InputNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__InputNumber__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'time-input',
  components: { InputNumber: __WEBPACK_IMPORTED_MODULE_0__InputNumber___default.a },
  props: ['model', 'value'],
  data: function data() {
    return {
      hours: 12,
      minutes: 48
    };
  },

  methods: {
    updateValue: function updateValue(model, value) {
      this[model] = Number(value);
      var timeInSeconds = this.minutes * 60 + this.hours * 60 * 60;
      this.$emit('update-value', this.model, timeInSeconds);
    },
    hitMinuteMax: function hitMinuteMax(value) {
      this.minutes = 0;
      this.hours = this.hours + 1;
      var timeInSeconds = this.minutes * 60 + this.hours * 60 * 60;
      this.$emit('update-value', this.model, timeInSeconds);
    },
    hitMinuteMin: function hitMinuteMin(value) {
      this.minutes = 59;
      this.hours = this.hours - 1;
      var timeInSeconds = this.minutes * 60 + this.hours * 60 * 60;
      this.$emit('update-value', this.model, timeInSeconds);
    }
  }

});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'range-slider',
  props: {
    model: {
      default: null,
      type: String
    },
    min: {
      default: "1",
      type: String
    },
    max: {
      default: "1000",
      type: String
    },
    step: {
      default: "1",
      type: String
    },
    value: {
      default: 500,
      type: Number
    },
    isDollar: {
      default: false,
      type: Boolean
    }
  },
  data: function data() {
    return {
      currentValue: null
    };
  },

  computed: {
    gradientFill: function gradientFill() {

      if (this.currentValue) {
        return (100 - this.currentValue / this.max * 100).toFixed(2);
      } else {
        return (100 - this.value / this.max * 100).toFixed(2);
      }
    },
    toolTip: function toolTip() {
      if (this.currentValue) {
        var offset = void 0;
        if (this.currentValue > 1000) {
          offset = -14;
        } else {
          offset = -7;
        }
        return offset - 1 * (this.currentValue / this.max) * 37;
      } else {
        return -7 - 1 * (this.value / this.max) * 37;
      }
    }
  },
  methods: {
    updateValue: function updateValue(e) {
      this.currentValue = e.target.value;
      this.$emit('update-value', this.model, e.target.value);
    }
  }

});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'results',
  props: ["recoveryTimeObjective", "recoveryPointObjective", "dataDisrupted", "timeBetweenBackups", "timeInitiateBackup", "affectedEmployees", "averageWage", "overheadCost", "businessLost", "recoverySpeed"],

  filters: {
    currency: function currency(value) {
      if (!value) return '';
      value = value.toString();
      return "$" + value.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    },
    timeFormat: function timeFormat(value) {
      value = Math.floor(value);
      var days = Math.floor(value / 86400);
      var hours = Math.floor(value / 3600) % 24;
      var minutes = Math.floor(value / 60) % 60;
      return days + " DAYS " + hours + " HRS " + minutes + " MINS ";
    }
  },
  computed: {
    hourlyRevenueCost: function hourlyRevenueCost() {
      var computedCost = this.affectedEmployees * this.averageWage + this.overheadCost + this.businessLost;
      return computedCost;
    },
    estimatedDowntime: function estimatedDowntime() {
      var recoveryTime = this.dataDisrupted * 8388608 / this.recoverySpeed;
      return recoveryTime + this.timeInitiateBackup;
    },
    totalCost: function totalCost() {
      return this.affectedEmployees * this.averageWage + this.overheadCost + this.businessLost;
    }

  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 17 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(15)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(30),
  /* scopeId */
  "data-v-05586cd5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(18)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(33),
  /* scopeId */
  "data-v-46c1965b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(20)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(35),
  /* scopeId */
  "data-v-548dd598",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(19)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(34),
  /* scopeId */
  "data-v-4bb3a73b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(21)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(36),
  /* scopeId */
  "data-v-9a22759a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "section-padding blue-lt"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "grid-5"
  }, [_c('p', [_vm._v("How many hours can your business go without accessing its critical systems or servers?")]), _vm._v(" "), _c('range-slider', {
    attrs: {
      "model": "recoveryTimeObjective",
      "max": "168",
      "value": _vm.recoveryTimeObjective
    },
    on: {
      "update-value": _vm.updateValue
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grid-5 grid-offset-2"
  }, [_c('p', [_vm._v("How many hours of production time on those servers are you willing to lose?")]), _vm._v(" "), _c('range-slider', {
    attrs: {
      "model": "recoveryPointObjective",
      "value": _vm.recoveryPointObjective,
      "max": "168"
    },
    on: {
      "update-value": _vm.updateValue
    }
  })], 1)])]), _vm._v(" "), _c('section', {
    staticClass: "section-padding blue-dk"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "grid-5 justify-content"
  }, [_c('p', [_vm._v("How many gigabytes of data are on your critical business systems? Critical systems are the systems essential to your business operations.")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "grid-7"
  }, [_c('input-number', {
    attrs: {
      "min": "0",
      "max": "9999",
      "value": _vm.dataDisrupted,
      "label": "GB",
      "model": "dataDisrupted"
    },
    on: {
      "update-value": _vm.updateValue
    },
    model: {
      value: (_vm.dataDisrupted),
      callback: function($$v) {
        _vm.dataDisrupted = _vm._n($$v)
      },
      expression: "dataDisrupted"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "grid-5 grid-offset-2 justify-content"
  }, [_c('p', [_vm._v("How often do you currently back up these systems, e.g. what is the time between each backup? ")]), _vm._v(" "), _c('input-time', {
    attrs: {
      "value": _vm.timeBetweenBackups,
      "model": "timeBetweenBackups"
    },
    on: {
      "update-value": _vm.updateValue
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grid-5 margin-top__lg"
  }, [_c('p', [_vm._v("How long does it take to initiate your recovery process? This is the amount of time that it will take you to prepare the systems for a recovery or restore.")]), _vm._v(" "), _c('input-time', {
    attrs: {
      "value": _vm.timeInitiateBackup,
      "model": "timeInitiateBackup"
    },
    on: {
      "update-value": _vm.updateValue
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grid-5 grid-offset-2 margin-top__lg"
  }, [_c('p', [_vm._v("Are you recovering data from a local network, or the cloud? This affects the speed at which the data can be recovered.")]), _vm._v(" "), _c('input-switch', {
    attrs: {
      "model": "recoverySpeed",
      "nameOne": "local",
      "nameTwo": "cloud",
      "labelOne": "Local",
      "labelTwo": "Cloud",
      "valueOne": "716800",
      "valueTwo": "30720"
    },
    on: {
      "update-value": _vm.updateValue
    }
  })], 1)])]), _vm._v(" "), _c('section', {
    staticClass: "section-padding blue-lt"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "grid-5 justify-content"
  }, [_c('p', [_vm._v("How many employees would be affected if your critical systems failed?")]), _vm._v(" "), _c('range-slider', {
    attrs: {
      "model": "affectedEmployees",
      "value": _vm.affectedEmployees,
      "max": "1000"
    },
    on: {
      "update-value": _vm.updateValue
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grid-5 grid-offset-2 justify-content"
  }, [_c('p', [_vm._v("What is the revenue generated per hour by these employees?")]), _vm._v(" "), _c('range-slider', {
    attrs: {
      "model": "businessLost",
      "min": "0",
      "value": _vm.businessLost,
      "max": "10000",
      "isDollar": true
    },
    on: {
      "update-value": _vm.updateValue
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grid-5 margin-top__lg justify-content"
  }, [_c('p', [_vm._v("What is the average hourly wage of an employee using one of your critical systems?")]), _vm._v(" "), _c('range-slider', {
    attrs: {
      "model": "averageWage",
      "value": _vm.averageWage,
      "max": "500",
      "isDollar": true
    },
    on: {
      "update-value": _vm.updateValue
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grid-5 grid-offset-2 margin-top__lg justify-content"
  }, [_c('p', [_vm._v("What is the average hourly overhead cost of an employee using a critical system?")]), _vm._v(" "), _c('range-slider', {
    attrs: {
      "model": "overheadCost",
      "value": _vm.overheadCost,
      "min": "0",
      "max": "500",
      "isDollar": true
    },
    on: {
      "update-value": _vm.updateValue
    }
  })], 1)])]), _vm._v(" "), _c('results', {
    attrs: {
      "recoveryTimeObjective": _vm.recoveryTimeObjective,
      "recoveryPointObjective": _vm.recoveryPointObjective,
      "dataDisrupted": _vm.dataDisrupted,
      "timeBetweenBackups": _vm.timeBetweenBackups,
      "timeInitiateBackup": _vm.timeInitiateBackup,
      "affectedEmployees": _vm.affectedEmployees,
      "averageWage": _vm.averageWage,
      "overheadCost": _vm.overheadCost,
      "businessLost": _vm.businessLost,
      "recoverySpeed": _vm.recoverySpeed
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid-12"
  }, [_c('h2', [_vm._v("Set Your Recovery Objectives")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid-12"
  }, [_c('h2', [_vm._v("Recovery Process & Data Storage")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid-12"
  }, [_c('h2', [_vm._v("Downtime & Recovery Costs")])])
}]}

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('calculator')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "wrap grid-center"
  }, [_c('div', {
    staticClass: "grid-8 grid-offset-2 text-center"
  }, [_c('h1', [_vm._v("RECOVERY TIME CALCULATOR")]), _vm._v(" "), _c('p', [_vm._v("Evaluate your Recovery Time and Recovery Point Objectives")])])])])
}]}

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "number-input"
  }, [_c('div', {
    staticClass: "input-button decrease",
    on: {
      "click": _vm.decrease
    }
  }, [_vm._v("−")]), _c('input', {
    attrs: {
      "type": "number",
      "name": _vm.model,
      "min": _vm.min,
      "max": _vm.max
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.updateValue
    }
  }), _c('div', {
    staticClass: "input-button increase",
    on: {
      "click": _vm.increase
    }
  }, [_vm._v("+")])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.model
    }
  }, [_vm._v(_vm._s(_vm.label))])])
},staticRenderFns: []}

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "switch"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": function($event) {
        $event.stopPropagation();
        _vm.updateValue($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label",
    class: {
      active: !_vm.optionTwo
    }
  }, [_vm._v(_vm._s(_vm.labelOne))]), _vm._v(" "), _c('div', {
    staticClass: "switch-icon"
  }, [_c('img', {
    class: {
      right: _vm.optionTwo
    },
    attrs: {
      "src": __webpack_require__(24)
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "label",
    class: {
      active: _vm.optionTwo
    }
  }, [_vm._v(_vm._s(_vm.labelTwo))])])
},staticRenderFns: []}

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "range-slider"
  }, [_c('div', {
    staticClass: "fill"
  }), _vm._v(" "), _c('div', {
    staticClass: "empty",
    style: ({
      width: _vm.gradientFill + '%'
    })
  }), _vm._v(" "), _c('input', {
    staticClass: "slider-input",
    attrs: {
      "type": "range",
      "min": _vm.min,
      "max": _vm.max,
      "step": _vm.step
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.updateValue
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "marker"
  }, [_c('div', {
    staticClass: "min marker-label"
  }, [_vm._v(_vm._s(_vm.isDollar ? '$' : null) + _vm._s(_vm.min))]), _vm._v(" "), _c('div', {
    staticClass: "middle marker-label"
  }, [_vm._v(_vm._s(_vm.isDollar ? '$' : null) + _vm._s(_vm.max / 2))]), _vm._v(" "), _c('div', {
    staticClass: "max marker-label"
  }, [_vm._v(_vm._s(_vm.isDollar ? '$' : null) + _vm._s(_vm.max))])]), _vm._v(" "), _c('div', {
    ref: "rangeTooltip",
    staticClass: "range-value",
    style: ({
      left: 100 - _vm.gradientFill + '%',
      marginLeft: _vm.toolTip + 'px'
    })
  }, [_vm._v(_vm._s(_vm.isDollar ? '$' : null) + _vm._s(_vm.value))])])
},staticRenderFns: []}

/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "grid-6"
  }, [_c('input-number', {
    attrs: {
      "min": "0",
      "max": "120",
      "value": _vm.hours,
      "model": "hours",
      "label": "Hours"
    },
    on: {
      "update-value": _vm.updateValue
    },
    model: {
      value: (_vm.hours),
      callback: function($$v) {
        _vm.hours = _vm._n($$v)
      },
      expression: "hours"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grid-6"
  }, [_c('input-number', {
    attrs: {
      "min": "0",
      "max": "59",
      "value": _vm.minutes,
      "model": "minutes",
      "label": "Minutes"
    },
    on: {
      "update-value": _vm.updateValue,
      "hit-minute-max": _vm.hitMinuteMax,
      "hit-minute-min": _vm.hitMinuteMin
    },
    model: {
      value: (_vm.minutes),
      callback: function($$v) {
        _vm.minutes = _vm._n($$v)
      },
      expression: "minutes"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section-padding results blue-dk"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "grid-4"
  }, [_c('h2', [_vm._v("Calculate your recovery cost")]), _vm._v(" "), _c('div', {
    staticClass: "total-cost"
  }, [_vm._v(_vm._s(_vm._f("currency")(Math.floor(_vm.hourlyRevenueCost * (_vm.estimatedDowntime / 3600)))))]), _vm._v(" "), _c('div', {
    staticClass: "total-cost-label"
  }, [_vm._v("TOTAL COST TO BUSINESS")])]), _vm._v(" "), _c('div', {
    staticClass: "grid-4 grid-offset-1"
  }, [_c('h3', [_vm._v("Recovery Process")]), _vm._v(" "), _c('div', {
    staticClass: "data-group"
  }, [_c('svg', {
    attrs: {
      "width": "22px",
      "height": "17px",
      "viewBox": "0 0 22 17",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Artboard",
      "transform": "translate(-847.000000, -2892.000000)",
      "fill-rule": "nonzero",
      "fill": "#07F0D7"
    }
  }, [_c('g', {
    attrs: {
      "id": "Final-Calc",
      "transform": "translate(0.000000, 2612.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Recovery-Process",
      "transform": "translate(845.000000, 212.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6.125,85 L19.875,85 C22.153375,85 24,83.2093333 24,81 L2,81 C2,83.2093333 3.846625,85 6.125,85 Z M20,82 L21,82 L21,83 L20,83 L20,82 Z M22.625,68 L3.375,68 L2,79 L24,79 L22.625,68 Z",
      "id": "Shape"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "data"
  }, [_vm._v(_vm._s(_vm.dataDisrupted) + " GB")]), _vm._v(" "), _c('div', {
    staticClass: "data-label"
  }, [_vm._v("Critical Systems Data")])]), _vm._v(" "), _c('div', {
    staticClass: "data-group"
  }, [_c('svg', {
    attrs: {
      "width": "22px",
      "height": "22px",
      "viewBox": "0 0 22 22",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Artboard",
      "transform": "translate(-845.000000, -3009.000000)",
      "fill-rule": "nonzero",
      "fill": "#07F0D7"
    }
  }, [_c('g', {
    attrs: {
      "id": "Final-Calc",
      "transform": "translate(0.000000, 2612.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Recovery-Process",
      "transform": "translate(845.000000, 212.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11,185 C12.4946667,185 13.9203333,185.290333 15.277,185.871 C16.6336667,186.451667 17.803,187.233 18.785,188.215 C19.767,189.197 20.5483333,190.366333 21.129,191.723 C21.7096667,193.079667 22,194.505333 22,196 C22,197.494667 21.7096667,198.920333 21.129,200.277 C20.5483333,201.633667 19.767,202.803 18.785,203.785 C17.803,204.767 16.6336667,205.548333 15.277,206.129 C13.9203333,206.709667 12.4946667,207 11,207 C9.50533333,207 8.07966667,206.709667 6.723,206.129 C5.36633333,205.548333 4.197,204.767 3.215,203.785 C2.233,202.803 1.45166667,201.633667 0.871,200.277 C0.290333333,198.920333 5.32907052e-15,197.494667 0,196 C-5.32907052e-15,194.505333 0.290333333,193.079667 0.871,191.723 C1.45166667,190.366333 2.233,189.197 3.215,188.215 C4.197,187.233 5.36633333,186.451667 6.723,185.871 C8.07966667,185.290333 9.50533333,185 11,185 Z M11,187 C9.78133333,187 8.616,187.238333 7.504,187.715 C6.392,188.191667 5.435,188.831 4.633,189.633 C3.831,190.435 3.19166667,191.392 2.715,192.504 C2.23833333,193.616 2,194.781333 2,196 C2,197.218667 2.23833333,198.384 2.715,199.496 C3.19166667,200.608 3.831,201.565 4.633,202.367 C5.435,203.169 6.392,203.808333 7.504,204.285 C8.616,204.761667 9.78133333,205 11,205 C12.2186667,205 13.384,204.761667 14.496,204.285 C15.608,203.808333 16.565,203.169 17.367,202.367 C18.169,201.565 18.8083333,200.608 19.285,199.496 C19.7616667,198.384 20,197.218667 20,196 C20,194.781333 19.7616667,193.616 19.285,192.504 C18.8083333,191.392 18.169,190.435 17.367,189.633 C16.565,188.831 15.608,188.191667 14.496,187.715 C13.384,187.238333 12.2186667,187 11,187 L11,187 Z M11,189 C11.276,189 11.5116667,189.097667 11.707,189.293 C11.9023333,189.488333 12,189.724 12,190 L12,195.586 L14.711,198.289 C14.9036667,198.481667 15,198.718667 15,199 C15,199.281333 14.9036667,199.518333 14.711,199.711 C14.5183333,199.903667 14.2813333,200 14,200 C13.7186667,200 13.4816667,199.903667 13.289,199.711 L10.289,196.711 C10.0963333,196.518333 10,196.281333 10,196 L10,190 C10,189.724 10.0976667,189.488333 10.293,189.293 C10.4883333,189.097667 10.724,189 11,189 Z",
      "id": "Shape"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "data"
  }, [_vm._v(_vm._s(_vm._f("timeFormat")(_vm.timeBetweenBackups)))]), _vm._v(" "), _c('div', {
    staticClass: "data-label"
  }, [_vm._v("Time between backups")])]), _vm._v(" "), _c('div', {
    staticClass: "data-group"
  }, [_c('svg', {
    attrs: {
      "width": "22px",
      "height": "22px",
      "viewBox": "0 0 22 22",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Artboard",
      "transform": "translate(-845.000000, -3009.000000)",
      "fill-rule": "nonzero",
      "fill": "#07F0D7"
    }
  }, [_c('g', {
    attrs: {
      "id": "Final-Calc",
      "transform": "translate(0.000000, 2612.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Recovery-Process",
      "transform": "translate(845.000000, 212.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11,185 C12.4946667,185 13.9203333,185.290333 15.277,185.871 C16.6336667,186.451667 17.803,187.233 18.785,188.215 C19.767,189.197 20.5483333,190.366333 21.129,191.723 C21.7096667,193.079667 22,194.505333 22,196 C22,197.494667 21.7096667,198.920333 21.129,200.277 C20.5483333,201.633667 19.767,202.803 18.785,203.785 C17.803,204.767 16.6336667,205.548333 15.277,206.129 C13.9203333,206.709667 12.4946667,207 11,207 C9.50533333,207 8.07966667,206.709667 6.723,206.129 C5.36633333,205.548333 4.197,204.767 3.215,203.785 C2.233,202.803 1.45166667,201.633667 0.871,200.277 C0.290333333,198.920333 5.32907052e-15,197.494667 0,196 C-5.32907052e-15,194.505333 0.290333333,193.079667 0.871,191.723 C1.45166667,190.366333 2.233,189.197 3.215,188.215 C4.197,187.233 5.36633333,186.451667 6.723,185.871 C8.07966667,185.290333 9.50533333,185 11,185 Z M11,187 C9.78133333,187 8.616,187.238333 7.504,187.715 C6.392,188.191667 5.435,188.831 4.633,189.633 C3.831,190.435 3.19166667,191.392 2.715,192.504 C2.23833333,193.616 2,194.781333 2,196 C2,197.218667 2.23833333,198.384 2.715,199.496 C3.19166667,200.608 3.831,201.565 4.633,202.367 C5.435,203.169 6.392,203.808333 7.504,204.285 C8.616,204.761667 9.78133333,205 11,205 C12.2186667,205 13.384,204.761667 14.496,204.285 C15.608,203.808333 16.565,203.169 17.367,202.367 C18.169,201.565 18.8083333,200.608 19.285,199.496 C19.7616667,198.384 20,197.218667 20,196 C20,194.781333 19.7616667,193.616 19.285,192.504 C18.8083333,191.392 18.169,190.435 17.367,189.633 C16.565,188.831 15.608,188.191667 14.496,187.715 C13.384,187.238333 12.2186667,187 11,187 L11,187 Z M11,189 C11.276,189 11.5116667,189.097667 11.707,189.293 C11.9023333,189.488333 12,189.724 12,190 L12,195.586 L14.711,198.289 C14.9036667,198.481667 15,198.718667 15,199 C15,199.281333 14.9036667,199.518333 14.711,199.711 C14.5183333,199.903667 14.2813333,200 14,200 C13.7186667,200 13.4816667,199.903667 13.289,199.711 L10.289,196.711 C10.0963333,196.518333 10,196.281333 10,196 L10,190 C10,189.724 10.0976667,189.488333 10.293,189.293 C10.4883333,189.097667 10.724,189 11,189 Z",
      "id": "Shape"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "data"
  }, [_vm._v(_vm._s(_vm._f("timeFormat")(_vm.timeInitiateBackup)))]), _vm._v(" "), _c('div', {
    staticClass: "data-label"
  }, [_vm._v("Recovery Process Initiation")])]), _vm._v(" "), _c('div', {
    staticClass: "data-group"
  }, [_c('svg', {
    attrs: {
      "width": "22px",
      "height": "22px",
      "viewBox": "0 0 22 22",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Artboard",
      "transform": "translate(-845.000000, -3009.000000)",
      "fill-rule": "nonzero",
      "fill": "#07F0D7"
    }
  }, [_c('g', {
    attrs: {
      "id": "Final-Calc",
      "transform": "translate(0.000000, 2612.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Recovery-Process",
      "transform": "translate(845.000000, 212.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11,185 C12.4946667,185 13.9203333,185.290333 15.277,185.871 C16.6336667,186.451667 17.803,187.233 18.785,188.215 C19.767,189.197 20.5483333,190.366333 21.129,191.723 C21.7096667,193.079667 22,194.505333 22,196 C22,197.494667 21.7096667,198.920333 21.129,200.277 C20.5483333,201.633667 19.767,202.803 18.785,203.785 C17.803,204.767 16.6336667,205.548333 15.277,206.129 C13.9203333,206.709667 12.4946667,207 11,207 C9.50533333,207 8.07966667,206.709667 6.723,206.129 C5.36633333,205.548333 4.197,204.767 3.215,203.785 C2.233,202.803 1.45166667,201.633667 0.871,200.277 C0.290333333,198.920333 5.32907052e-15,197.494667 0,196 C-5.32907052e-15,194.505333 0.290333333,193.079667 0.871,191.723 C1.45166667,190.366333 2.233,189.197 3.215,188.215 C4.197,187.233 5.36633333,186.451667 6.723,185.871 C8.07966667,185.290333 9.50533333,185 11,185 Z M11,187 C9.78133333,187 8.616,187.238333 7.504,187.715 C6.392,188.191667 5.435,188.831 4.633,189.633 C3.831,190.435 3.19166667,191.392 2.715,192.504 C2.23833333,193.616 2,194.781333 2,196 C2,197.218667 2.23833333,198.384 2.715,199.496 C3.19166667,200.608 3.831,201.565 4.633,202.367 C5.435,203.169 6.392,203.808333 7.504,204.285 C8.616,204.761667 9.78133333,205 11,205 C12.2186667,205 13.384,204.761667 14.496,204.285 C15.608,203.808333 16.565,203.169 17.367,202.367 C18.169,201.565 18.8083333,200.608 19.285,199.496 C19.7616667,198.384 20,197.218667 20,196 C20,194.781333 19.7616667,193.616 19.285,192.504 C18.8083333,191.392 18.169,190.435 17.367,189.633 C16.565,188.831 15.608,188.191667 14.496,187.715 C13.384,187.238333 12.2186667,187 11,187 L11,187 Z M11,189 C11.276,189 11.5116667,189.097667 11.707,189.293 C11.9023333,189.488333 12,189.724 12,190 L12,195.586 L14.711,198.289 C14.9036667,198.481667 15,198.718667 15,199 C15,199.281333 14.9036667,199.518333 14.711,199.711 C14.5183333,199.903667 14.2813333,200 14,200 C13.7186667,200 13.4816667,199.903667 13.289,199.711 L10.289,196.711 C10.0963333,196.518333 10,196.281333 10,196 L10,190 C10,189.724 10.0976667,189.488333 10.293,189.293 C10.4883333,189.097667 10.724,189 11,189 Z",
      "id": "Shape"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "data"
  }, [_vm._v(_vm._s(_vm._f("timeFormat")(_vm.estimatedDowntime)))]), _vm._v(" "), _c('div', {
    staticClass: "data-label"
  }, [_vm._v("Estimated Downtime")])])]), _vm._v(" "), _c('div', {
    staticClass: "grid-3"
  }, [_c('h3', [_vm._v("Downtime Costs")]), _vm._v(" "), _c('div', {
    staticClass: "data-group"
  }, [_c('svg', {
    attrs: {
      "width": "17px",
      "height": "17px",
      "viewBox": "0 0 17 17",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Artboard",
      "transform": "translate(-1178.000000, -2895.000000)",
      "fill-rule": "nonzero",
      "fill": "#07F0D7"
    }
  }, [_c('g', {
    attrs: {
      "id": "Final-Calc",
      "transform": "translate(0.000000, 2612.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Downtime-Costs",
      "transform": "translate(1175.000000, 212.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11.015,81.031 C13.687,81.031 19.031,82.344 19.031,85.015 L19.031,87.031 L3,87.031 L3,85.015 C3,82.343 8.344,81.031 11.016,81.031 L11.015,81.031 Z M11.015,79.015 C8.812,79.015 7.031,77.234 7.031,75.031 C7.031,72.828 8.812,71 11.015,71 C13.218,71 14.999,72.828 14.999,75.031 C14.999,77.234 13.218,79.015 11.015,79.015 Z",
      "id": "Shape"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "data"
  }, [_vm._v(_vm._s(_vm.affectedEmployees))]), _vm._v(" "), _c('div', {
    staticClass: "data-label"
  }, [_vm._v("Employees Affected")])]), _vm._v(" "), _c('div', {
    staticClass: "data-group"
  }, [_c('svg', {
    attrs: {
      "width": "22px",
      "height": "22px",
      "viewBox": "0 0 22 22",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Artboard",
      "transform": "translate(-1175.000000, -3009.000000)",
      "fill": "#07F0D7"
    }
  }, [_c('g', {
    attrs: {
      "id": "Final-Calc",
      "transform": "translate(0.000000, 2612.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Downtime-Costs",
      "transform": "translate(1175.000000, 212.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11,185 C12.4946667,185 13.9203333,185.290333 15.277,185.871 C16.6336667,186.451667 17.803,187.233 18.785,188.215 C19.767,189.197 20.5483333,190.366333 21.129,191.723 C21.7096667,193.079667 22,194.505333 22,196 C22,197.494667 21.7096667,198.920333 21.129,200.277 C20.5483333,201.633667 19.767,202.803 18.785,203.785 C17.803,204.767 16.6336667,205.548333 15.277,206.129 C13.9203333,206.709667 12.4946667,207 11,207 C9.50533333,207 8.07966667,206.709667 6.723,206.129 C5.36633333,205.548333 4.197,204.767 3.215,203.785 C2.233,202.803 1.45166667,201.633667 0.871,200.277 C0.290333333,198.920333 5.32907052e-15,197.494667 0,196 C-5.32907052e-15,194.505333 0.290333333,193.079667 0.871,191.723 C1.45166667,190.366333 2.233,189.197 3.215,188.215 C4.197,187.233 5.36633333,186.451667 6.723,185.871 C8.07966667,185.290333 9.50533333,185 11,185 Z M11,187 C9.78133333,187 8.616,187.238333 7.504,187.715 C6.392,188.191667 5.435,188.831 4.633,189.633 C3.831,190.435 3.19166667,191.392 2.715,192.504 C2.23833333,193.616 2,194.781333 2,196 C2,197.218667 2.23833333,198.384 2.715,199.496 C3.19166667,200.608 3.831,201.565 4.633,202.367 C5.435,203.169 6.392,203.808333 7.504,204.285 C8.616,204.761667 9.78133333,205 11,205 C12.2186667,205 13.384,204.761667 14.496,204.285 C15.608,203.808333 16.565,203.169 17.367,202.367 C18.169,201.565 18.8083333,200.608 19.285,199.496 C19.7616667,198.384 20,197.218667 20,196 C20,194.781333 19.7616667,193.616 19.285,192.504 C18.8083333,191.392 18.169,190.435 17.367,189.633 C16.565,188.831 15.608,188.191667 14.496,187.715 C13.384,187.238333 12.2186667,187 11,187 L11,187 Z",
      "id": "Shape",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "id": "$",
      "font-family": "DattoDINExp-Bold, Datto DIN Exp",
      "font-size": "16",
      "font-style": "expanded",
      "font-weight": "bold"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "7",
      "y": "202"
    }
  }, [_vm._v("$")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "data"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.averageWage)))]), _vm._v(" "), _c('div', {
    staticClass: "data-label"
  }, [_vm._v("Average Employee Wage")])]), _vm._v(" "), _c('div', {
    staticClass: "data-group"
  }, [_c('svg', {
    attrs: {
      "width": "22px",
      "height": "22px",
      "viewBox": "0 0 22 22",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Artboard",
      "transform": "translate(-1175.000000, -3009.000000)",
      "fill": "#07F0D7"
    }
  }, [_c('g', {
    attrs: {
      "id": "Final-Calc",
      "transform": "translate(0.000000, 2612.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Downtime-Costs",
      "transform": "translate(1175.000000, 212.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11,185 C12.4946667,185 13.9203333,185.290333 15.277,185.871 C16.6336667,186.451667 17.803,187.233 18.785,188.215 C19.767,189.197 20.5483333,190.366333 21.129,191.723 C21.7096667,193.079667 22,194.505333 22,196 C22,197.494667 21.7096667,198.920333 21.129,200.277 C20.5483333,201.633667 19.767,202.803 18.785,203.785 C17.803,204.767 16.6336667,205.548333 15.277,206.129 C13.9203333,206.709667 12.4946667,207 11,207 C9.50533333,207 8.07966667,206.709667 6.723,206.129 C5.36633333,205.548333 4.197,204.767 3.215,203.785 C2.233,202.803 1.45166667,201.633667 0.871,200.277 C0.290333333,198.920333 5.32907052e-15,197.494667 0,196 C-5.32907052e-15,194.505333 0.290333333,193.079667 0.871,191.723 C1.45166667,190.366333 2.233,189.197 3.215,188.215 C4.197,187.233 5.36633333,186.451667 6.723,185.871 C8.07966667,185.290333 9.50533333,185 11,185 Z M11,187 C9.78133333,187 8.616,187.238333 7.504,187.715 C6.392,188.191667 5.435,188.831 4.633,189.633 C3.831,190.435 3.19166667,191.392 2.715,192.504 C2.23833333,193.616 2,194.781333 2,196 C2,197.218667 2.23833333,198.384 2.715,199.496 C3.19166667,200.608 3.831,201.565 4.633,202.367 C5.435,203.169 6.392,203.808333 7.504,204.285 C8.616,204.761667 9.78133333,205 11,205 C12.2186667,205 13.384,204.761667 14.496,204.285 C15.608,203.808333 16.565,203.169 17.367,202.367 C18.169,201.565 18.8083333,200.608 19.285,199.496 C19.7616667,198.384 20,197.218667 20,196 C20,194.781333 19.7616667,193.616 19.285,192.504 C18.8083333,191.392 18.169,190.435 17.367,189.633 C16.565,188.831 15.608,188.191667 14.496,187.715 C13.384,187.238333 12.2186667,187 11,187 L11,187 Z",
      "id": "Shape",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "id": "$",
      "font-family": "DattoDINExp-Bold, Datto DIN Exp",
      "font-size": "16",
      "font-style": "expanded",
      "font-weight": "bold"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "7",
      "y": "202"
    }
  }, [_vm._v("$")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "data"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.overheadCost)))]), _vm._v(" "), _c('div', {
    staticClass: "data-label"
  }, [_vm._v("Average Employee Overhead Cost")])]), _vm._v(" "), _c('div', {
    staticClass: "data-group"
  }, [_c('svg', {
    attrs: {
      "width": "22px",
      "height": "22px",
      "viewBox": "0 0 22 22",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Artboard",
      "transform": "translate(-1175.000000, -3009.000000)",
      "fill": "#07F0D7"
    }
  }, [_c('g', {
    attrs: {
      "id": "Final-Calc",
      "transform": "translate(0.000000, 2612.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Downtime-Costs",
      "transform": "translate(1175.000000, 212.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11,185 C12.4946667,185 13.9203333,185.290333 15.277,185.871 C16.6336667,186.451667 17.803,187.233 18.785,188.215 C19.767,189.197 20.5483333,190.366333 21.129,191.723 C21.7096667,193.079667 22,194.505333 22,196 C22,197.494667 21.7096667,198.920333 21.129,200.277 C20.5483333,201.633667 19.767,202.803 18.785,203.785 C17.803,204.767 16.6336667,205.548333 15.277,206.129 C13.9203333,206.709667 12.4946667,207 11,207 C9.50533333,207 8.07966667,206.709667 6.723,206.129 C5.36633333,205.548333 4.197,204.767 3.215,203.785 C2.233,202.803 1.45166667,201.633667 0.871,200.277 C0.290333333,198.920333 5.32907052e-15,197.494667 0,196 C-5.32907052e-15,194.505333 0.290333333,193.079667 0.871,191.723 C1.45166667,190.366333 2.233,189.197 3.215,188.215 C4.197,187.233 5.36633333,186.451667 6.723,185.871 C8.07966667,185.290333 9.50533333,185 11,185 Z M11,187 C9.78133333,187 8.616,187.238333 7.504,187.715 C6.392,188.191667 5.435,188.831 4.633,189.633 C3.831,190.435 3.19166667,191.392 2.715,192.504 C2.23833333,193.616 2,194.781333 2,196 C2,197.218667 2.23833333,198.384 2.715,199.496 C3.19166667,200.608 3.831,201.565 4.633,202.367 C5.435,203.169 6.392,203.808333 7.504,204.285 C8.616,204.761667 9.78133333,205 11,205 C12.2186667,205 13.384,204.761667 14.496,204.285 C15.608,203.808333 16.565,203.169 17.367,202.367 C18.169,201.565 18.8083333,200.608 19.285,199.496 C19.7616667,198.384 20,197.218667 20,196 C20,194.781333 19.7616667,193.616 19.285,192.504 C18.8083333,191.392 18.169,190.435 17.367,189.633 C16.565,188.831 15.608,188.191667 14.496,187.715 C13.384,187.238333 12.2186667,187 11,187 L11,187 Z",
      "id": "Shape",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "id": "$",
      "font-family": "DattoDINExp-Bold, Datto DIN Exp",
      "font-size": "16",
      "font-style": "expanded",
      "font-weight": "bold"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "7",
      "y": "202"
    }
  }, [_vm._v("$")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "data"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.hourlyRevenueCost)))]), _vm._v(" "), _c('div', {
    staticClass: "data-label"
  }, [_vm._v("Hourly Revenue Cost")])])])])])
},staticRenderFns: []}

/***/ })
],[12]);


// WEBPACK FOOTER //
// static/js/app.fdb6a67eab26a524a0f8.js